/**
 * Page templates a theme can choose from. Each theme stores its choice in its
 * settings (productTemplate, cartTemplate, checkoutTemplate), so two clients
 * can run different page designs on the same code.
 *
 * To add a design: build the component (see README.md in this folder),
 * register it in index.js, and add its value and label here.
 */
export const PAGE_TEMPLATES = {
  product: {
    settingKey: "productTemplate",
    label: "Product page",
    options: [{ value: "classic", label: "Classic" }],
  },
  cart: {
    settingKey: "cartTemplate",
    label: "Cart page",
    options: [{ value: "classic", label: "Classic" }],
  },
  checkout: {
    settingKey: "checkoutTemplate",
    label: "Checkout",
    options: [{ value: "classic", label: "Classic" }],
  },
};

export const DEFAULT_TEMPLATE = "classic";

// The theme editor shows these as one "Page templates" group.
export const PAGE_TEMPLATE_SETTINGS = {
  id: "page-templates",
  title: "Page templates",
  hint: "Product, cart, and checkout designs",
  category: "Page Templates",
  fields: Object.values(PAGE_TEMPLATES).map((page) => ({
    key: page.settingKey,
    label: page.label,
    type: "select",
    fallback: DEFAULT_TEMPLATE,
    options: page.options,
  })),
};
